
import axios from "axios";
import TabContext from "context/TabContext";
import { useCallback, useContext, useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";

const GlobalAlert = () => {
  const { alertRef, alertHeight } = useContext(TabContext);
  const [globalAlertRef] = alertRef;
  const [setAlertHeight] = alertHeight;
  const [showAlert, setShowAlert] = useState(false);
  const [hideForever, setHideForever] = useState(false);
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [showTitle, setShowTitle] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);

  const isMobile = useMediaQuery({ maxWidth: "768px" });

  useEffect(() => {
    if (showAlert) {
      setAlertHeight(globalAlertRef?.current?.clientHeight + 16);
      return;
    }

    setAlertHeight(0);
  }, [showAlert]);

  useEffect(() => {
    if (hideForever) {
      return;
    }

    if (startDate && expiryDate) {
      const checkDateRange = () => {
        const currentDate = new Date();
        // Check if the current date is between the start and expiry dates
        if (currentDate >= startDate && currentDate <= expiryDate) {
          setShowAlert(true);
        } else {
          setShowAlert(false);
        }
      };

      // Initial check
      checkDateRange();

      // Set an interval to check the date every second
      const intervalId = setInterval(checkDateRange, 1000);

      // Cleanup interval when component unmounts
      return () => clearInterval(intervalId);
    }
  }, [startDate, expiryDate]);

  useEffect(() => {
    const fetchGlobalAlert = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CMS_BASE_URL}/global-alerts?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const jsonResponse = response.data.data[0];

        setText(jsonResponse?.description);
        setStartDate(new Date(jsonResponse?.startDate)); // Assuming the API returns ISO date strings
        setExpiryDate(new Date(jsonResponse?.expiryDate));
        setTitle(jsonResponse?.title);
        setShowTitle(jsonResponse?.showTitle);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchGlobalAlert();
  }, []);

  return (
    <Alert
      id="globalAlert"
      show={showAlert && !hideForever}
      onClose={() => {
        setHideForever(true);
        setAlertHeight(0);
      }}
      dismissible
      ref={globalAlertRef}
      style={{ marginBottom: 0 }}
    >
      <div style={isMobile ? { maxHeight: '100px', overflow: 'scroll' } : {}}>
        {showTitle && <strong><u>{title}</u></strong>}
        {text && parse(text)}
      </div>
    </Alert>
  );
};

export default GlobalAlert;